/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */
/* eslint no-param-reassign: ["error", { "props": false }] */

const search = () => {
  const btnEdit = document.querySelectorAll('.js-edit');
  const btnSave = document.querySelectorAll('.js-save');
  const btnDismiss = document.querySelectorAll('.js-dismiss');
  const searchOverlay = document.querySelector('.js-search-overlay');
  const choosers = document.querySelectorAll('.js-chooser');
  document.querySelectorAll('.js-checkbox-group-target').forEach(input => {
    input.addEventListener('click', () => {
      const parentInput = input
        .closest('.js-toggleable-group')
        .querySelector('.js-checkbox-group');
      if (input.classList.contains('js-current-chooser')) {
        input.classList.remove('js-current-chooser');
        if (!parentInput.querySelectorAll('.js-current-chooser')) {
          parentInput.classList.remove('js-current-group-chooser');
        }
      } else {
        input.classList.add('js-current-chooser');
        if (!parentInput.classList.contains('js-current-group-chooser')) {
          parentInput.classList.add('js-current-group-chooser');
        }
      }
    });
  });
  document.querySelectorAll('.js-checkbox-group').forEach(input => {
    input.addEventListener('click', () => {
      const parentInputs = input
        .closest('.js-toggleable-group')
        .querySelectorAll('.js-checkbox-group-target');
      if (input.classList.contains('js-current-group-chooser')) {
        input.classList.remove('js-current-group-chooser');
        parentInputs.forEach(element => {
          element.classList.remove('js-current-chooser');
        });
      } else {
        input.classList.add('js-current-group-chooser');
        parentInputs.forEach(element => {
          element.classList.add('js-current-chooser');
        });
      }
    });
  });
  btnEdit.forEach(btn => {
    btn.addEventListener(
      'click',
      event => {
        event.preventDefault();
        if (btn === event.target) {
          searchOverlay.classList.toggle('is-active');
          choosers.forEach(element => {
            element.classList.add('u-hidden');
          });
          const inputsContainer = document.querySelector(
            `.js-chooser[data-chooser="${event.target.dataset.chooser}"]`,
          );
          inputsContainer.classList.remove('u-hidden');
          document.querySelector('.c-popup').scrollTop = 0;
        }
        document.querySelectorAll('.c-label__container').forEach(e => {
          e.classList.remove('is-active');
        });
      },
      true,
    );
  });
  btnSave.forEach(btn => {
    btn.addEventListener(
      'click',
      event => {
        event.preventDefault();
        if (btn === event.target) {
          searchOverlay.classList.remove('is-active');
          const activeElems = event.target.parentElement.parentElement.querySelectorAll(
            'input:checked',
          );
          const chooser = document.querySelector(
            `.js-edit[data-chooser="${
              event.target.parentElement.parentElement.dataset.chooser
            }"]`,
          ).parentElement;
          chooser.querySelector('.js-filter-counter').innerHTML =
            activeElems.length;
          chooser.classList.add('is-full');
          let activated = [];
          activeElems.forEach(element => {
            activated.push(element.value);
          });
          activated = activated.join(',');
          chooser.querySelector('input').value = activated;
          chooser
            .querySelector('input')
            .dispatchEvent(new CustomEvent('change'));
          document.querySelectorAll('.js-current-chooser').forEach(input => {
            input.classList.remove('js-current-chooser');
          });
          document
            .querySelectorAll('.js-current-group-chooser')
            .forEach(input => {
              input.classList.remove('js-current-group-chooser');
            });
        }
      },
      true,
    );
  });
  const evt = new CustomEvent('change');
  btnDismiss.forEach(btn => {
    btn.addEventListener(
      'click',
      event => {
        event.preventDefault();
        if (btn === event.target) {
          document.querySelectorAll('.js-current-chooser').forEach(input => {
            input.checked = !input.checked;
            input.classList.remove('js-current-chooser');
            input.dispatchEvent(evt);
          });
          // document
          //   .querySelectorAll('.js-current-group-chooser')
          //   .forEach(input => {
          //     if (input.checked === true) {
          //       input.checked = false;
          //       const parentInput = input.parentElement.querySelector(
          //         '.is-halfly-completed',
          //       );
          //       if (parentInput) {
          //         parentInput.classList.remove('is-halfly-completed');
          //       }
          //     } else {
          //       input.checked = true;
          //     }
          //     input.classList.remove('js-current-group-chooser');
          //   });
          searchOverlay.classList.remove('is-active');
        }
      },
      true,
    );
  });
};

export default search;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/search.js